import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Breadcrumbs } from '@cp/ds/src/components/breadcrumbs';
import { Container } from '@cp/ds/src/components/container';
import { Helmet } from 'react-helmet';
import { RouteConfigComponentProps } from 'react-router-config';
import { RoutedLink } from 'src/shared/ui/link';
import Header from 'src/widgets/header';
import { PaymentPolicyWidget } from 'src/widgets/legal';

const PaymentPolicy: React.FC<RouteConfigComponentProps> = () => {
  return (
    <Box>
      <Helmet>
        <title>Политика оплаты и тарифные планы - YouHelp.ru</title>
        <meta content="Информация по оплате и тарифных планах, а также об оформлении возврата денег." name="description" />
      </Helmet>

      <Header />

      <Container sx={{ pb: { xs: 6, md: 20 } }}>
        <Breadcrumbs
          LinkComponent={RoutedLink}
          items={[
            {
              path: '/',
              label: 'Главная',
            },
            {
              path: '',
              label: 'Оплата и возврат',
            },
          ]}
          sx={{ my: 2 }}
        />
        <PaymentPolicyWidget />
      </Container>
    </Box>
  );
};

export default PaymentPolicy;
